'use strict';

const swatchableAttribute = require('../product/swatchableAttribute');
const productBase = require('../product/base');
const urlUtils = require('../util/urlUtils');

module.exports = {
    openStoreDrawer: function () {
        $('.js-pdp-store-drawer-open').on('click', function() {
            const queryString = $(this).attr('data-href');
            const urlParameters = urlUtils.getQueryParams(queryString);
            const $location = $('input[type="radio"][name=sourcing-location]:checked');
            const currentStoreId = $location.attr('data-value-id');

            $('body').trigger('store-drawer:open', {
                pid: urlParameters.get('pid'),
                search: true,
                showInventoryLimit: urlParameters.get('readyToOrder'),
                currentStore: currentStoreId
            });
        });
    },
    selectStorePdp: function () {
        $('body').on('click', '.js-select-store-link', function (e) {
            e.preventDefault();

            const storeID = $(this).data('store-id');
            const $location = $('input[type="radio"][name=sourcing-location]:checked');
            let $productContainer = $location.closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $location.closest('.product-detail');
            }
            const options = productBase.getOptions($productContainer);
            let tempOptions = JSON.parse(options);
            tempOptions.forEach((item) => {
                if (item.optionId === 'sourcingLocation') {
                    item.selectedValueId = String(storeID);
                }
            });
            let url = $location.attr('data-href');
            swatchableAttribute.attributeSelect(`${url}&options=${JSON.stringify(tempOptions)}`, $productContainer);
        });
    }
};
